import { FaCartShopping, FaMagnifyingGlass, FaPen, FaTrash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from '../../components/DynamicListingPage';
import { Chip, IconButton, Stack, Tooltip } from '@mui/material';
import { formatWeight } from '../../utils/functions';
import { useMutation, useQuery } from '@tanstack/react-query';
import { deletePriceGroup, getPriceGroups } from "../../helpers/http_price_groups_requests";
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';

export default function PriceGroups() {

    const { verifyPermission } = usePermissions();

    const { id: user_id } = useAuth();

    const { data, isFetching, refetch } = useQuery({ queryKey: ['getPriceGroups'], queryFn: getPriceGroups, staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const deleteMutation = useMutation({
        mutationFn: (id) => deletePriceGroup(id, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar este grupo de preços?', () => {
            deleteMutation.mutate(id);
        });
    };

    const componentName = 'orders';

    const columns = [
        {
            field: 'name',
            headerName: 'Nome',
        },
        {
            field: 'description',
            headerName: 'Descrição',
        },
        {
            field: 'high_gold_index',
            headerName: 'Ouro 18K Trabalhado',
        },
        {
            field: 'low_gold_index',
            headerName: 'Ouro 10K',
        },
        {
            field: 'actions',
            headerName: 'Ações',
        },
    ];

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/grupo-de-indice-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/grupo-de-indice-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    const renderWeights = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            <Chip label={formatWeight(row.weights.high_gold_weight)} color="secondary" />
            <Chip label={formatWeight(row.weights.silver_weight)} color="grey" />
        </Stack>
    );

    return <ListingPage canAddData={verifyPermission(componentName, 3)} isLoading={isFetching} icon={FaCartShopping} pageTitle={"Grupos de Índices"} addButtonTitle={"grupo"} addPath={'/grupo-de-indice-cadastro'} columns={columns} data={dataList} actions={renderActions} weights={renderWeights} />;
};